const iframeSanitizer = (html: string) => {
  const iframeOpener = html.indexOf('<iframe');
  const iframeCloser = html.indexOf('</iframe>') + 9;
  const iframe = html.slice(iframeOpener, iframeCloser);

  const withinIframeOpener = iframe.indexOf('<span');
  const withinIframeCloser = iframe.indexOf('</iframe>');
  const withinIframe = iframe.slice(withinIframeOpener, withinIframeCloser);

  const formattedIframe = iframe.replace(withinIframe, '');

  const formattedContent = html.replace(iframe, formattedIframe);

  return formattedContent;
};

export default iframeSanitizer;
